import apiClient from './apiClient';

export interface QueryParams {
  order_no_from?: string;
  order_no_to?: string;
  date_from?: string;     // YYYY-MM-DD
  date_to?: string;       // YYYY-MM-DD
  filter_mode?: number;   // 1=全部, 2=未說明
}

export interface ReportRow {
  order_no: string;
  order_date: string;
  order_type: string;   // 繳庫單 / 託工入庫
  memo1: string;
  memo2: string;
  details: string;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  message?: string;
}

export const d328Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d328/query', params);
    return res.data;
  },
};
